module.exports = __webpack_public_path__ + "media/images/600px_Right_Banner_NoBalls-fae0cf631008eb9a596001b2501d1ea5.png";